<div class="container-filtro">
  <div class="col-left">
    <div class="bloco-img">
      <img
        src="{{ BASE_IMG_URL }}assets/logo/logo-rdo-branco.png"
        alt=""
      />
      <p>
        Dê um upgrade <br />
        no seu plano <br />
        da Rede de Obras!
      </p>
    </div>
  </div>

  <div class="col-right">
    <p class="descricao" [innerHTML]="getBannerText()"></p>
    <a class="fazer-upgrade" [href]="getUpgradeLink()"  rel="noopener noreferrer" target="_blank"
      >FAZER UPGRADE DE PLANO!</a
    >
  </div>
</div>
